import React from 'react';
import TablaPresupuesto from '../components/presupuesto/tablapresupuesto';

function CrearPresupuesto() {
  return (
      <div className='col-12 d-flex justify-content-center row'>
        <TablaPresupuesto />
      </div>
  );
}

export default CrearPresupuesto;




// WEBPACK FOOTER //
// ./src/pages/crearpresupuesto.js